module.exports = __webpack_public_path__ + "img/graphic-land-mix.0ccabeb4.webp";